import { gsap } from 'gsap';
import getCookie from '../utils/getCookie';
import setCookie from '../utils/setCookie';
export class Popup {
    el;
    formID;
    token;
    constructor(el) {
        this.el = el;
        this.formID = parseInt(this.el.getAttribute('data-form') || '0');
        this.token = this.el.getAttribute('data-token') || 'yes';
        this.init();
    }
    init() {
        const seen = getCookie('scrimPopupSeen');
        const submitted = getCookie('scrimPopupSubmitted');
        if (seen === this.token || submitted === this.token)
            return;
        // $(this.el)
        //   .on('click', '[href="#popup-close"]', (e) => {
        //     e.preventDefault()
        //     this.close()
        //   })
        document.querySelector('[href="#popup-close"]')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
        });
        // $(document)
        //   .on('gform_confirmation_loaded', (e, form_id) => {
        //     if (form_id === this.formID ) {
        //       setCookie('scrimPopupSubmitted', this.token)
        //     }
        //   })
        setTimeout(() => { this.open(); }, 5000);
    }
    open() {
        //$('html').addClass('popup-open')
        //$(this.el).addClass('open')
        document.querySelector('html')?.classList.add('popup-open');
        this.el.classList.add('open');
        const tl = gsap.timeline();
        const imageEl = this.el.querySelector('.popup-image');
        const contentEl = this.el.querySelector('.popup-content');
        tl.to(this.el, { duration: 0.3, pointerEvents: 'auto', opacity: 1 }, 0);
        tl.fromTo(imageEl, { opacity: 0, x: -24 }, { duration: 0.5, opacity: 1, x: 0 }, 0.25);
        tl.fromTo(contentEl, { opacity: 0, x: +24 }, { duration: 0.5, opacity: 1, x: 0 }, 0.3);
    }
    close() {
        //$('html').removeClass('popup-open')
        //$(this.el).removeClass('open')
        document.querySelector('html')?.classList.remove('popup-open');
        this.el.classList.remove('open');
        const tl = gsap.timeline();
        const imageEl = this.el.querySelector('.popup-image');
        const contentEl = this.el.querySelector('.popup-content');
        tl.fromTo(contentEl, { opacity: 1, x: 0 }, { duration: 0.25, opacity: 0, x: +24 }, 0);
        tl.fromTo(imageEl, { opacity: 1, x: 0 }, { duration: 0.25, opacity: 0, x: -24 }, 0);
        tl.to(this.el, { duration: 0.3, pointerEvents: 'none', opacity: 0 }, 0.15);
        setCookie('scrimPopupSeen', this.token, 7);
    }
}
